var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 772,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 773,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 774,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 775,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 776,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2710;